export default {"src":"/_next/static/media/logo.28f5a55f.svg","height":24,"width":112};